import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './MoveFolderDialog.scss';
import EastIcon from '@mui/icons-material/East';
import { Avatar, Box, Checkbox, FormControlLabel, Grid, Tab, Tabs, TextField, useTheme } from '@mui/material';
import { useEffect, useMemo } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Description, SearchOutlined } from '@mui/icons-material';
import { IuserList } from '../../../../entities/Trainer/MockTrainer';
import TrainerService from '../../../../services/trainer/TrainerService';
import AssignmentConfirmationDialog from '../AssignmentConfirmationDialog/AssignmentConfirmationDialog';
import Loading from '../../../Loading/Loading';
import { trackEvent } from '../../../../App';
import { AmplitudeEvents } from '../../../../shared/enums';
import { useTranslation } from 'react-i18next';
import { Toast } from '../../../Notifications/Notification';
import TableContainer from '../../../Analytics/ProcedureReports/TableContainer';
import { getFormattedDateFromUnixTime } from '../../../../shared/utils/formateDate';
import { SmallFolderIcon } from '../../../Icons/CdsIcons';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box component="div" sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface Props {
  openDialog: boolean;
  closeDialog: () => void;
  folders?: any;
  handleMoveFolder?: any;
}

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function MoveFolderDialog(props) {
  const [checkedFolder, setCheckedFolder] = React.useState<any>('');
  const [searchText, setSearchText] = React.useState('');
  const [activeRow, setActiveRow] = React.useState(-1);
  const [foldersData, setFoldersData] = React.useState<any>([]);
  const handleClose = () => {
    props.closeDialog();
    setCheckedFolder('');
    props.setCheckedMoveToFolderId('');
    props.closeDialog();
  };

  const { t } = useTranslation();

  const onRowClick = (row) => {
    setActiveRow(row.id);
    if (checkedFolder === row.id) {
      setCheckedFolder('');
      props.setCheckedMoveToFolderId('');
    } else {
      setCheckedFolder(row.id);
      props.setCheckedMoveToFolderId(row.original.folderId);
    }
  };

  const theme = useTheme();

  const columnsComment = useMemo(
    () =>
      [
        {
          Header: 'Name',
          accessor: 'name',
          Cell: ({ value, row }) => (
            <Typography sx={{ marginLeft: '8px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography sx={{ marginRight: '8px' }}>
                <SmallFolderIcon />
              </Typography>
              <Typography sx={{ marginLeft: '8px', fontSize: '16px', fontWeight: '600' }}>{value}</Typography>
            </Typography>
          ),
        },
        {
          Header: 'Description',
          accessor: 'description',
          disableSortBy: true,
          Cell: ({ value, row }) => <Typography sx={{ fontSize: '14px', fontWeight: 400, opacity: '70%', color: '#312D32' }}>{value}</Typography>,
        },
        {
          Header: 'Date',
          accessor: 'createdOn',
          Cell: ({ value, row }) => <span style={{ fontSize: '14px', fontWeight: 400, opacity: '70%', color: '#312D32' }}>{getFormattedDateFromUnixTime(value)}</span>,
        },
      ].filter(Boolean),
    [],
  );

  const getFoldersData = () => {
    const arr: any = [];
    props.folders?.map((folder) => {
      arr.push({
        folderId: folder.folderId,
        name: folder.title,
        description: folder.description,
        createdOn: folder.createdOn,
      });
    });
    setFoldersData(arr);
  };

  const filterSearchFolderData = async (searchText) => {
    const searchValue = searchText.toLowerCase();

    if (searchValue === '') {
      await getFoldersData();
      return;
    }

    await getFoldersData();

    const searchResult = foldersData.filter(folderData => {
      const name = folderData?.name?.toLowerCase() || '';
      const description = folderData?.description?.toLowerCase() || '';
      return name.includes(searchValue) || description.includes(searchValue);
    });

    setFoldersData(searchResult);
  };

  useEffect(() => {
    filterSearchFolderData(searchText);
  }, [searchText]);

  useEffect(() => {
    getFoldersData();
  }, [props.folders]);

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={props.openDialog}
      scroll="paper"
      PaperProps={{
        sx: {
          minWidth: '67.93rem',
          maxHeight: '39.18rem',
          minHeight: '39.18rem',
          padding: '1.5rem',
          position: 'relative',
        },
      }}
    >
      {/* {!contentReady && (
          <Box component="div">
            <Loading />
          </Box>
        )} */}
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography sx={{ verticalAlign: 'middle', fontSize: '20px' }}>{`${t('COMMON.MOVE')} (${props?.folders?.length})`} </Typography>{' '}
        <Typography>
          {' '}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Typography>
      </Box>
      {props.folders && props.folders?.length !== 0 && (
        <>
          <TextField
            sx={{ width: '208px', height: '32px', marginTop: '8px', mb: '8px' }}
            fullWidth
            id="standard-bare"
            variant="outlined"
            placeholder={t('COMMON.SEARCH')}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <IconButton>
                  <SearchOutlined />
                </IconButton>
              ),
            }}
          />

          <Box sx={{ marginTop: '8px' }}>
            <TableContainer columns={columnsComment} data={foldersData} onRowClick={onRowClick} checkedFolder={checkedFolder} />
          </Box>
        </>
      )}

      {props.folders && props.folders?.length === 0 && (
        <Box component="div" style={{ position: 'absolute', top: '50%', left: '50%' }} className="assign-user-msg">
          {t('COMMON.NO_FOLDER_EXIST')}
        </Box>
      )}

      {props?.folders && props?.folders?.length > 0 && (
        <DialogActions style={{ display: 'flex' }}>
          <Button variant="outlined" onClick={handleClose} sx={{ marginRight: '12px' }}>
            {' '}
            {t('BUTTON.CANCEL')}
          </Button>
          <Button variant="contained" type="submit" disabled={checkedFolder.length === 0} onClick={props.handleMoveFolder}>
            {' '}
            {t('COMMON.MOVE')}
          </Button>
        </DialogActions>
      )}
    </BootstrapDialog>
  );
}
